import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 27 26"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M10.125 8.667H6.75V13h3.375v13h5.625V13h4.097l.403-4.333h-4.5V6.86c0-1.035.216-1.444 1.254-1.444h3.246V0h-4.284c-4.045 0-5.841 1.715-5.841 5v3.667Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }